// extracted by mini-css-extract-plugin
export default {"InstagramLogo":"InstaRedirect_InstagramLogo__Y4fP-","InstaLink":"InstaRedirect_InstaLink__1efo-"};